import React from "react";
import { Stack, Typography } from "@mui/material";
import PlayerHeadshot from "./PlayerHeadshot";

const PlayerNameCell = ({
  playerId,
  name,
  onPlayerClick,
  photoUrl,
  sport = "mlb",
  loading = "eager",
}) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    sx={{ minWidth: 0, height: "100%", cursor: playerId ? "pointer" : "default" }}
    onClick={() => playerId && onPlayerClick?.(playerId)}
  >
    <PlayerHeadshot
      playerId={playerId}
      sport={sport}
      src={photoUrl}
      size={32}
      showTooltip={false}
      showLoading={false}
      enabled={Boolean(playerId) && photoUrl === undefined}
      loading={loading}
    />
    <Typography
      variant="body2"
      fontWeight={600}
      noWrap
      color="primary.light"
      title={name}
      sx={{ "&:hover": playerId ? { textDecoration: "underline" } : undefined }}
    >
      {name}
    </Typography>
  </Stack>
);

export default PlayerNameCell;
